import { SwitchDimensions, SWITCH_SIZES } from "./types";
import { SIZE_CONFIG_MAP } from "./constants";

const useSwitch = (
  size: SWITCH_SIZES,
  checked: boolean,
  onClick: () => void,
  disabled?: boolean
) => {
  const config = SIZE_CONFIG_MAP[size];
  const circleSize = config.height - 4;

  const dimensions: SwitchDimensions = {
    width: config.width,
    height: config.height,
    circleSize,
  };

  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  const circlePosition = checked ? config.width - circleSize - 2 : 2;

  return {
    dimensions,
    handleClick,
    circlePosition,
    textClass: config.textClass,
  };
};

export default useSwitch;
